<script lang="js" setup>
// import TheNavigation from "@/components/TheNavigation.vue";
</script>

<template>
  <div class="min-h-[90vh] bg-primary-dark flex flex-col">
    <!-- <TheNavigation /> -->
    <div
      class="2xl:max-w-screen-2xl max-w-screen-xl container mx-auto flex flex-col md:flex-row lg:flex-row lg:justify-between lg:items-center flex-1 px-4 sm:px-6 md:px-8 gap-6 sm:gap-8 md:gap-12 lg:gap-0"
    >
      <div
        class="max-w-[840px] flex flex-col gap-y-3 sm:gap-y-4 md:gap-y-5 lg:gap-y-4 order-2 md:order-1 lg:order-1"
      >
        <h3
          class="uppercase font-black tracking-widest text-base sm:text-lg md:text-xl lg:text-2xl bg-txt-gradient bg-clip-text text-transparent"
        >
          Seamless polling within Google Chat
        </h3>
        <h2
          class="font-poppins font-bold text-white text-2xl sm:text-3xl md:text-4xl lg:text-5.5xl leading-tight md:leading-tight lg:leading-tight"
        >
          Revolutionize Team Collaboration With Chat-Polls
        </h2>
        <p
          class="text-white/50 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed md:leading-relaxed lg:leading-loose"
        >
          Chat-Polls brings the power of decision-making directly to your Google
          Chat workspace. Whether you're leading a project, conducting a survey,
          or making quick decisions, our intuitive tool makes polling simple,
          fast, and collaborative.
        </p>
      </div>

      <div
        class="flex justify-center md:block lg:block order-1 md:order-2 lg:order-2"
      >
        <img
          alt="hero image"
          class="w-full max-w-xs sm:max-w-sm md:max-w-md md:w-full lg:w-full lg:max-w-none lg:max-h-[750px] object-contain"
          src="@/assets/images/hero-image.png"
        />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
